import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 300px;
  height: 100px;
  background-color: #020202;
  box-shadow: 5px 5px 5px black;
  margin: 20px;
  padding: 10px 15px 10px 20px;
  border-radius: 10px;
`;

export const ContainerLabelMeTxt = styled.div`
  margin-left: 20px;
  h3 {
    margin-bottom: 5px;
  }
`;
